export default __webpack_public_path__ + "static/media/Backstage.2e42f3b4.png";